import { FIELD_REGEX } from './constants';
/**
 * @hidden
 */
export function fieldList(field) {
    var fields = [];
    field.replace(FIELD_REGEX, function (_match, index, indexAccessor, fieldName) {
        fields.push(index !== undefined ? index : (indexAccessor || fieldName));
    });
    return fields;
}
//# sourceMappingURL=fieldList.js.map